<template>
  <div class="multiple-select-choice relative">
    <el-select placeholder="请选择" v-model="issue.select" multiple :filterable="issue.enableFilter" @change="$emit('change')">
      <el-option
        class="fixed-width-select"
        v-for="item in items"
        :key="item.id"
        style="max-width: 200px"
        :label="item.text"
        :value="item.id"
      />
    </el-select>
    <template v-if="selectOtherItems.length">
      <ul class="mt-2">
        <li v-for="item in selectOtherItems" :key="item.length">
          <div v-html="item.content.richText"></div>
          <el-input v-model="item.value" placeholder="请输入" class="mt-2" />
        </li>
      </ul>
    </template>
    <div v-if="view" class="absolute inset-0 z-50"></div>
    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress && issue.select.length">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems" />
      <template v-if="voteItems.length > 5">
        <el-button class="w-full" @click="onShowMoreRank">查看更多排名</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import { transformRichText2Text } from 'dygc'
import selectVote from './select-vote'
export default {
  name: 'MultipleSelectChoice',
  changeExpr: 'issue.select',
  mixins:[selectVote],
  computed: {
    selectOtherItems() {
      return this.issue.select
        .map(id => {
          return this.issue.getItemById(id)
        })
        .filter(i => i.is_other_item)
    },
    items() {
      return this.issue.items.map(item => {
        return {
          id: item.id,
          text: transformRichText2Text(item.content.richText)
        }
      })
    }
  }
}
</script>
